import "./downloadApp.css";
import { connect } from "react-redux";

const DownloadApp = () => {
  return (
    <div>
      <div className="downlaodAppContainer">
        <div className="downloadApp_img">
          <img
            src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/012141ad-93f2-4a8c-a6ff-ab9d2f25e1bd.png"
            alt="Mobile"
          />
        </div>
        <div className="downloadApp_text">
          <h1>DOWNLOAD APP</h1>
          <p>
            Keeping a check on your health made easy with the app. Available on
            both Google Play Store and App Store. Get easy access to health
            check ups with quick turnaround time.
          </p>
          <div className="downloadapp_Container">
            <a
              href="https://play.google.com/store/apps/details?id=com.redcliffelabs&showAllReviews=true"
              target="_blank"
            >
              <img
                src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/2d9761b1-3062-4375-8f00-da28a1e23126.png"
                alt="playstore image"
                href="https://play.google.com/store/apps/details?id=com.redcliffelabs&showAllReviews=true"
              />
            </a>
            <a href="https://apps.apple.com/in/app/redcliffe-labs/id1602990503" target="_blank">
              <img
                src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/0f959dad-f102-4504-ab09-5cd9b4572ba9.png"
                alt="appstore image"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default connect()(React.memo(DownloadApp));
